// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"2a84c1c1","455":"63c70fee","488":"5af0629b","977":"f9f0dc07"}[chunkId] + ".chunk.js";
};